import { Injectable } from 'angular-ts-decorators';

/**
 * It's supposed to be used as a source of current date to facilitate tests.
 */
@Injectable('dateSource')
export class DateSource {
  constructor(private moment) {
    'ngInject';
  }

  /**
   *
   * Generates current date. To be mocked in tests.
   * @returns {object}
   * Date
   */
  now(): Date {
    return this.moment().toDate();
  }

  /**
   *
   * Outputs a Unix timestamp for current time
   * @returns {number}
   * unix timestamp
   */
  unix(): number {
    return this.moment().unix();
  }
}
